// Experience Mode visibility — persisted client-side only (no local DB).
// Keyed per user so opting out on one account never re-triggers for them.
const KEY = "revq.expmode.dismissed";

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

export function userKey(user) {
  return String(user?.email || user?.id || "anon").toLowerCase();
}

// A "new user" is one who has never seen / dismissed Experience Mode on this browser.
export function hasSeenExperience(user) {
  return !!load()[userKey(user)];
}

export function dismissExperience(user) {
  const map = load();
  map[userKey(user)] = new Date().toISOString();
  try {
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* storage unavailable — fail quietly */
  }
}
